import React, { useEffect, useState } from 'react'
import { associationCampaign, isAssociationCampaignActive } from '../screens/associationCampaign'
import '../screens/association-popup.css'

const AssociationCampaignPopup = () => {
  const [isOpen, setIsOpen] = useState(() => (
    isAssociationCampaignActive()
  ))

  useEffect(() => {
    if (!isOpen) return undefined

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false)
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isOpen])

  if (!isOpen) return null

  return (
    <section
      className='association-popup'
      role='dialog'
      aria-modal='false'
      aria-labelledby='association-popup-title'
    >
      <button
        type='button'
        className='association-popup__close'
        onClick={() => setIsOpen(false)}
        aria-label='Cerrar aviso'
      >
        ×
      </button>
      <p className='association-popup__eyebrow'>{associationCampaign.eyebrow}</p>
      <h2 id='association-popup-title'>{associationCampaign.title}</h2>
      <p className='association-popup__subtitle'>{associationCampaign.subtitle}</p>
      {associationCampaign.paragraphs.map((paragraph) => (
        <p className='association-popup__text' key={paragraph}>{paragraph}</p>
      ))}
      <a className='association-popup__link' href={associationCampaign.ctaUrl}>
        {associationCampaign.ctaLabel}
      </a>
    </section>
  )
}

export default AssociationCampaignPopup
